import * as T from 'three';
import { initScene } from './sceneInit';
import { RobotInterface } from './interfaces/robotInterface';
import { LoadSaveInterface } from './interfaces/loadSaveInterface';
import { CameraInterface } from './interfaces/cameraInterface';
import { createTestButtons } from './ui/testButtons';

const GITHUB_LINK = "https://gjnguyen18.github.io/urdf-loader-test/";

/*
    Starts the program up
    Sets up initial interfaces
    Sets up THREE.js scene
    
*/
export function runModelViewer() {

    let scene, camera, renderer, controls, tooltips, helpScreenData, tabSettings;
    let raycaster = new T.Raycaster();
    let mouse = new T.Vector2();

    let baselink = window.location.href.split('?')[0];;
    let tooltipLink = baselink + "helpData/tooltips.json";
    let helpScreenLink = baselink + "helpData/helpScreenSections.json"

    let getHelpSections = () => {
        fetch(helpScreenLink)
            .then(response => response.text())
            .then(helpDataText => {
                helpScreenData = JSON.parse(helpDataText);
                init();
            }).catch((error) => {
                console.log(error)
                helpScreenData = {};
            })
    }

    fetch(tooltipLink)
    .then(response => response.text())
    .then(tooltipText => {
        tooltips = JSON.parse(tooltipText);
        getHelpSections();
    }).catch((error) => {
        console.log(error)
        tooltips = {};
        getHelpSections();
    })

    let init = () => {
        let initData = initScene(helpScreenData);
        scene = initData.scene;
        camera = initData.camera;
        renderer = initData.renderer;
        controls = initData.controls;
        tabSettings = initData.tabSettings

        // ui references
        let interfaces = {
            scene: scene,
            renderer: renderer,
            camera: camera,
            controls: controls,
            animation: null,
            lines: null,
            joints: null,
            robot: null,
            query: null,
            cameraInterface: null,
            raycaster: raycaster,
            tooltips: tooltips,
            tabs: tabSettings
        }
        let robotInterface = new RobotInterface(scene, interfaces);
        interfaces.robot = robotInterface;

        let cameraInterface = new CameraInterface(interfaces);
        interfaces.cameraInterface = cameraInterface;

        let loadSaveInterface = new LoadSaveInterface(interfaces);
        interfaces.query = loadSaveInterface;
        let urlSearchParams = new URLSearchParams(window.location.search);
        let params = Object.fromEntries(urlSearchParams.entries());
        loadSaveInterface.loadQueryString(params);

        createTestButtons(interfaces)

        // raycast
        raycaster.params.Line.threshold = 0.0025;
        let sphereInter = new T.Mesh(
            new T.SphereGeometry(0.005),
            new T.MeshBasicMaterial({ color: 0xff0000 })
        );
        sphereInter.visible = false;
        scene.add(sphereInter);

        function onMouseMove(event) {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
        }

        // when the user clicks
        function onMouseDown(event) {
            raycaster.setFromCamera(mouse, camera);
            if (interfaces.lines) {
                let lineMeshes = interfaces.lines.getAllLineMeshes();
                if (lineMeshes.length > 0) {
                    let lineExists = false;
                    lineMeshes.forEach(mesh => {
                        if (mesh != null) {
                            lineExists = true;
                        }
                    })
                    if (lineExists) {
                        let intersects = raycaster.intersectObjects(lineMeshes, false);
                        if (intersects.length > 0) {
                            let lineGroup = interfaces.lines.getAllLines().find(group => group.line.mesh == intersects[0].object);
                            interfaces.robot.setRobot(lineGroup.robotGroup.robot.robotName);
                            interfaces.animation.setMotion(lineGroup.motionName);
                            lineGroup.line.setRobotConfig(intersects[0].point);
                        }
                    }
                }
            }
            interfaces.robot.robotClick();
        }

        // animation loop
        function render() {
            interfaces.robot.updateAllRobots();

            // raycast
            raycaster.setFromCamera(mouse, camera);
            sphereInter.visible = false;
            if (interfaces.lines) {
                let lineMeshes = interfaces.lines.getAllLineMeshes();
                if (lineMeshes.length > 0) {
                    let intersects = raycaster.intersectObjects(lineMeshes, false);
                    if (intersects.length > 0) {
                        sphereInter.visible = true;
                        sphereInter.position.copy(intersects[0].point);
                    }
                }
            }

            renderer.render(scene, camera);
            requestAnimationFrame(render);
        }

        window.addEventListener('mousemove', onMouseMove, false);
        document.body.addEventListener('click', onMouseDown, true);
        render();
    }
}
